<template>
  <h3 class="text-10 text-black font-bold mb-18">
    <slot />
  </h3>
</template>
